<!--
组件名：编辑表单组件【全局组件】
描述： 同上
作者：林伟鑫
创建时间：2023-10-08 15:45
更新时间：2023-10-08 17.52

使用方法：
<s-edit-form :formData="表单数据源" :formFieldData="字段表数据源" @changeForm="事件函数"></s-edit-form>

插槽：
actionBtn 按钮插槽 
插槽使用示例：
<template v-slot:actionBtn="slotProps">
  <u-button type="primary" @click="changeForm(slotProps.formItem)">测试</u-button>
</template>
-->
<template>
  <view class="edit-form">
    <!-- 字段数据源 -->
    <view v-for="(formFieldItem, index) in formFieldData" :key="index">
      <!-- 标题 -->
      <view v-if="formFieldItem.headline" class="form-headline">{{
        formFieldItem.headline || ""
      }}</view>

      <!-- 表单数据源 -->
      <view
        v-for="(formDataItem, formDataIdx) in formData"
        :key="formDataItem.id"
        class="form-data-list"
      >
        <u--form
          labelPosition="left"
          :model="formDataItem"
          ref="uForm"
          labelAlign="right"
        >
          <!-- 字段数据 -->
          <u-form-item
            v-for="(fieldItem, fieIdIdx) in formFieldItem.fieldList"
            :key="fieIdIdx"
            :label="fieldItem.title"
          >
            <!-- 文本框类型 -->
            <u--input
              v-if="fieldItem.type === 'input'"
              v-model="formDataItem[fieldItem.field]"
              class="inp"
              fontSize="24rpx"
              placeholder="请输入"
              border="none"
              @change="(e) => changeForm(fieldItem, formDataItem, e)"
            ></u--input>
            <!-- 日期选择类型 || 下拉选择器类型 -->
            <view
              v-else-if="
                fieldItem.type === 'date' || fieldItem.type === 'picker'
              "
              style="width: 100%"
              @click="changeForm(fieldItem, formDataItem)"
            >
              <u-input
                v-model="formDataItem[fieldItem.field]"
                class="inp"
                fontSize="24rpx"
                placeholder="请选择"
                :suffixIcon="
                  fieldItem.type === 'date' ? 'calendar' : 'arrow-down'
                "
                border="none"
                suffixIconStyle="color: #909399"
              ></u-input>
            </view>
            <view v-else style="font-size: 24rpx">{{
              fieldData(formDataItem[fieldItem.field])
            }}</view>
          </u-form-item>
        </u--form>
      </view>
    </view>
    <!-- 日期选择器 -->
    <u-datetime-picker
      closeOnClickOverlay
      :show="dateShow"
      v-model="dateTimeValue"
      mode="date"
      @cancel="cancel('date')"
      @close="cancel('date')"
      @confirm="(e) => confirm(e, 'date')"
    ></u-datetime-picker>
    <!-- 下拉框选择器 -->
    <u-picker
      closeOnClickOverlay
      :show="pickerShow"
      keyName="label"
      :columns="pickerList"
      @confirm="(e) => confirm(e, 'picker')"
      @cancel="cancel('picker')"
      @close="cancel('picker')"
    ></u-picker>
  </view>
</template>
<script>
import s from "@/config/sj.js";
export default {
  name: "sListForm",
  props: {
    // 表单展示数据
    formData: {
      type: Array,
      default: () => [],
    },
    /** formFieldData 字段表数据源
     * 单数据源示例：
      {
          headline: "物料信息", 
          fieldList: [
            {
              title: "单价",
              field: "price",
              value: "priceValue",
              type: "picker",
              list: [
                {
                  value: "0",
                  label: "客供",
                },
                {
                  value: "1",
                  label: "大货",
                },
              ],
            },
          ],
        },
     * 字段数据
     * 固定字段：headline fieldList title field value type list
     * @param {String} headline 信息块标题【根据情况而定】
     * @param {Array} fieldList 字段数据表【必需】
     * @param {String} title 字段名称【必需】
     * @param {String} field 字段【必需】
     * @param {String} value 前端作展示字段用【根据情况而定】
     * @param {String} type 类型字段 text 文本类型 picker 下拉框类型 date 时间类型 input 输入框类型【必需】
     * @param {Array} list 作为下拉框数据源【根据情况而定】
     */
    formFieldData: {
      type: Array,
      default: () => [],
    },
    // 时间格式 默认 Y-M-D h:min:s
    dateType: {
      type: String,
      default:'Y-M-D h:min:s'
    }
  },
  data() {
    return {
      // 日期选择展示
      dateShow: false,
      // 下拉框选择展示
      pickerShow: false,
      // 下拉框选择数据
      pickerList: [],
      // 日期选择数据
      dateTimeValue: Number(new Date()),
      // 操作字段数据源
      fieldItem: {},
      // 数据源
      formDataItem: {},
    };
  },
  computed: {
    // 处理字段数据
    fieldData() {
      return (data) => {
        return data ?? "-";
      };
    },
  },
  methods: {
    /**
     * 关闭事件
     * @param {String} type 关闭组件的类型
     */
    cancel(type) {
      this[type + "Show"] = false;
    },
    /**
     * 选择事件
     * @param {Object} fieldItem 当前操作的字段数据源
     * @param {Object} formDataItem 数据源
     * @param {String} e 输入框的值 其他类型无
     */
    changeForm(fieldItem, formDataItem, e) {
      this.fieldItem = fieldItem;
      this.formDataItem = formDataItem;
      if (fieldItem.type === "input") {
        this.$set(formDataItem, [this.fieldItem.field], e);
        this.$emit("changeForm", e, this.fieldItem, this.formDataItem);
        return;
      }
      if (fieldItem.type === "picker") {
        this.pickerList = [].concat([fieldItem?.list || []]);
      }
      this[fieldItem.type + "Show"] = true;
    },
    /**
     * 时间选择 | 下拉框 确定事件
     * @param {Object} e 原始数据
     * @param {String} type 下拉框 picker | 时间 date
     */
    confirm(e, type) {
      const { value } = e;
      if (type === "picker") {
        // this.fieldItem.fun(value[0])
        this.$set(this.formDataItem, [this.fieldItem.field], value[0].label);
        this.$set(this.formDataItem, [this.fieldItem.value], value[0].value);
        this.$emit("changeForm", value[0], this.fieldItem, this.formDataItem);
      }
      if (type === "date") {
        const timeValue = s.formateDate(new Date(value), this.dateType);
        // const timeValue =
        //   new Date(parseInt(value))
        //     .toLocaleString()
        //     .replace(/:\d{1,2}$/, "")
        //     .replaceAll("/", "-") + ":00";
        this.$set(this.formDataItem, [this.fieldItem.field], timeValue);
        this.$emit("changeForm", timeValue, this.fieldItem, this.formDataItem);
      }
      this.cancel(type);
    },
  },
};
</script>
<style lang="less" scoped scoped>
@import "./s-edit-form.less";
</style>